"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SETTINGS = void 0;

/**
 * @module skat-js/constants
 * @project Web-panel
 * @author Andrey Nikulin (<izhastron@gmail.com>) Thursday, 04 August 2021 3:39:49 pm
 * @copyright 2015 - 2021 SKAT LLC, Delive LLC
 * 
 */

/**
 * Настройки терминала комплекса SKAT
 */
const SETTINGS = {
  /**
  * @summary Показывать адрес назначения в свободных заказах
  */
  SHOW_DST_FO: 'show_dst_fo',

  /**
  * @summary Отсылать время принятия заказа
  * @description Отсылать время принятия заказа в примечании
  */
  ORDER_SENDREGTIME: 'order_sendregtime',

  /**
  * @summary Показывать адрес назначения в заказах по отметке
  */
  SHOW_DST_ORD: 'show_dst_ord',

  /**
  * @summary Сообщать о подъезде машины
  * @description Сообщать клиенту когда машина подъезжает по адресу
  */
  ROBOT_ONPLACE_ENABLE: 'robot_onplace_enable',

  /**
  * @summary Таймаут ожидания
  * @description (сек) время, за которое водитель должен указать время подъезда
  */
  WAIT_TIMEOUT: 'wait_timeout',

  /**
  * @summary Отсылать gps операторам
  */
  SEND_GPS_TO_OPERATORS: 'send_gps_to_operators',

  /**
  * @summary Автоматически подтверждать заказ
  * @description Как только водитель ставит время подъезда, ему тут же высылается подтверждение
  */
  ORDER_AUTOCONFIRM: 'order_autoconfirm',

  /**
  * @summary Сообщать автомобиль на предварительных
  * @description Сообщать клиенту автомобиль когда водитель берет предварительный заказ
  */
  ROBOT_RESERV_ENABLE: 'robot_reserv_enable',

  /**
  * @summary Включить подтверждение
  * @description включить автоматический отзвон клиентам с сообщением автомобиля клиенту
  */
  ROBOT_CONFIRM_ENABLE: 'robot_confirm_enable',

  /**
  * @summary Разрешить отказываться
  * @description Включить возможность отказа водителя от заказа с сохранением позиции в очереди
  */
  BAN_REJECT: 'ban_reject',

  /**
  * @summary Отсылать имя клиента
  */
  ORDER_SENDNAME: 'order_sendname',

  /**
  * @summary Отказывать клиентам
  * @description автоматическое сообщение что нет машин
  */
  ROBOT_REJECT_ENABLE: 'robot_reject_enable',

  /**
  * @summary Отправлять сообщения
  * @description Если выключить то система не будет отсылать никаких сообщений
  */
  SMS_ENABLE: 'sms_enable',

  /**
  * @summary Заблокировать запуск таксометра
  * @description Запрет запуска таксометра из главного меню
  */
  TERMINAL_TAXOMETR_BLOCK: 'terminal_taxometr_block',

  /**
  * @summary Показывать стоимость по тарифу
  * @description Отображать стоимость километра и стоянки на экране таксометра
  */
  TERMINAL_SHOWRATE: 'terminal_showrate',

  /**
  * @summary Проигрывать приветствие
  * @description Проигрывать приветствие при старте таксометра
  */
  TERMINAL_PLAY_HELLO: 'terminal_play_hello',

  /**
  * @summary Проигрывать благодарность
  * @description Проигрывать фразу благодарности в конце поездки
  */
  TERMINAL_PLAY_THANK: 'terminal_play_thank',

  /**
  * @summary Произносить стоимость поездки
  * @description произносить стоимость поездки голосом
  */
  TERMINAL_PLAY_PRICE: 'terminal_play_price',

  /**
  * @summary Сообщения блокировки
  * @description Данное сообщение будет отсылаться водителю если его заблокирует система из-за проблем с оплатой
  */
  BILLING_BLOCKMESSAGE: 'billing_blockmessage',

  /**
  * @summary Помечать висящие заказы через
  * @description Минут. Если никто не берет заказ в течении этого времени, он помечается статусом. Если не хотите использовать данную функцию, поставьте 0
  */
  ORDER_MARKREJECT: 'order_markreject',

  /**
  * @summary Максимальное время ожидания заказа (мин.)
  * @description Если водитель стоит на отметке больше этого времени, то заказ в любом случает отдается ему, даже если есть водитель, находящийся ближе
  */
  MAXWAIT: 'maxwait',

  /**
  * @summary Время подъезда
  * @description 6 времен для подъезда, разделенные запятыми. пример 1,3,5,7,9,12
  */
  ORDER_TIMES: 'order_times',

  /**
  * @summary Время блокировки
  * @description (сек) время блокировки в случае отказа водителя от заказа
  */
  BLOCK_TIME: 'block_time',

  /**
  * @summary Включить заказы с сайта
  * @description Принимать заказы с сайта
  */
  EXTORDER_WEB_ENABLED: 'extorder_web_enabled',

  /**
  * @summary Время принятия решения
  * @description сколько секунд давать на выбор времени подъезда
  */
  TERMINAL_TIMESELECT_TIMEOUT: 'terminal_timeselect_timeout',

  /**
  * @summary Шаблон сообщения для СМС-чека
  * @description допустимые переменные<br/>%id% - номер заказа<br/>%sum% - Стоимость<br/>%bonus% - Бонусный счет
  */
  SMS_BILL_TEMPLATE: 'sms_bill_template',

  /**
  * @summary Время видимости
  * @description За сколько минут заказ будет виден в диспетчерской при скрытых предварительных заказах
  */
  RESERV_ORDERS_VISIBLETIME: 'reserv_orders_visibletime',

  /**
  * @summary Блокировать после нескольких отказов
  * @description Через сколько отказов блокировать водителя, опция работает только если включена РАЗРЕШИТЬ ОТКАЗЫВАТЬСЯ
  */
  BAN_AFTER_REJECT: 'ban_after_reject',

  /**
  * @summary SMPP сервер
  * @description сервер для отправки сообщений
  */
  SMS_SMPP_HOST: 'sms_smpp_host',

  /**
  * @summary Запретить взятие предварительных
  * @description Запретить водителю самостоятельно забирать предварительный с терминала
  */
  RESERV_REJECTSET: 'reserv_rejectset',

  /**
  * @summary Разрешить звонить клиенту
  * @description Позволяет делать запрос на соединение с клиентом из программы
  */
  TERMINAL_CALL_ENABLE: 'terminal_call_enable',

  /**
  * @summary Кэшировать определения стоянки
  * @description Записывать в базу данных результат определения стоянки по координате
  */
  ORDER_CACHE_COORDS: 'order_cache_coords',

  /**
  * @summary Опережение подъезда
  * @description Максимальное время в секундах, на которое допускается раньше вызвать клиента при подъезде. Если ограничение не нужно, поставьте 0
  */
  TERMINAL_ONPLACEMAXINTERVAL: 'terminal_onplaceMaxInterval',

  /**
  * @summary Запрашивать стоимость поездки
  * @description Запрашивать подтверждение при закрытии таксометра. Водитель сможет ввести свою сумму
  */
  TERMINAL_ASKENTERPRICE: 'terminal_askEnterPrice',

  /**
  * @summary Час начала расчетных суток
  * @description Граница суток при посуточном расчете. Например если поставить 8, сутки будут считаться с 8 утра текущего дня до 8 утра следующего.<br/>Допустимые значения: 0-23
  */
  BILLING_STARTHOUR: 'billing_starthour',

  /**
  * @summary Интервал между заказами
  * @description Минимальный интервал в секундах между заказами с одного айпи адреса
  */
  EXTORDER_WEB_INTERVAL: 'extorder_web_interval',

  /**
  * @summary Показывать адрес назначения в предварительных заказах
  */
  RESERV_SHOW_DST: 'reserv_show_dst',

  /**
  * @summary Дистанция подъезда
  * @description Максимальное расстояние до клиента, при котором допускается нажимать кнопку "На месте". Если ограничение не нужно, поставьте 0
  */
  TERMINAL_ONPLACEMAXDIST: 'terminal_onplaceMaxDist',

  /**
  * @summary Интервал запроса подтверждения
  * @description Через сколько секунд запросить подтверждение повторно при отсутствии ответа
  */
  RESERV_ORDERS_CFRM_INTERVAL: 'reserv_orders_cfrm_interval',

  /**
  * @summary Минимальная версия для Symbian
  * @description Минимально допустимая версия ПО для коммуникаторов на базе Symbian
  */
  SOFT_MINVERSION_SYMBIAN: 'soft_minversion_symbian',

  /**
  * @summary Время запроса подтверждения
  * @description за сколько минут запрашивать подтверждение у водителя
  */
  RESERV_ORDERS_CFRM_TIME: 'reserv_orders_cfrm_time',

  /**
  * @summary Время ожидания доставки
  * @description Сколько секунд ждать подтверждения доставки сообщения, если сообщение за это время не доставиться до клиента, то система позвонит
  */
  SMS_TIMEOUT: 'sms_timeout',

  /**
  * @summary Порт для подключения NOWTAXI
  */
  NOWTAXI_PORT: 'nowtaxi_port',

  /**
  * @summary Отсылать свободный при регистрации
  * @description При регистрации на стоянке отсылать водителю первый свободный заказ, если есть свободные заказы на стоянке
  */
  ORDER_SENDFREEONREG: 'order_sendfreeonreg',

  /**
  * @summary IP адрес(а) процессингового центра
  * @description IP адрес в формате X.X.X.X сервера процессингового центра, с которого будут приходить уведомления об оплате. Если нужно несколько адресов, введите их через запятую без пробелов
  */
  BILLING_GEPARD_IP: 'billing_gepard_ip',

  /**
  * @summary Описание фотографий
  * @description Описание шагов фотоотчета
  */
  TERMINAL_PHOTO_DESCRIPTION: 'terminal_photo_description',

  /**
  * @summary Максимальная длительность
  * @description Ограничивает максимальный срок обещанного платежа не более указанного количества часов
  */
  PROMISED_PAYMENTS_MAX_LENGTH: 'promised_payments_max_length',

  /**
  * @summary Радиус поиска водителей (метров)
  * @description Поиск ближайшего водителя будет производится только в этом радиусе. Можно задать несколько значений через запятую, тогда поиск будет поэтапный
  */
  NEARRADIUS: 'nearradius',

  /**
  * @summary Время актуальности фото
  * @description Через какое время в часах считать фотоотчет неактуальным и снова запросить у водителя свежие фотографии
  */
  PHOTO_EXPIRE_TIME: 'photo_expire_time',

  /**
  * @summary Включить фотоосмотр
  * @description Включает возможность отправки фотографий авто на сервер.
  */
  TERMINAL_PHOTO_ENABLE: 'terminal_photo_enable',

  /**
  * @summary Показывать бонусы в списке свободных
  * @description При отключении в списке свободных не будет отображаться размер скидки на заказе
  */
  ORDER_SHOW_BONUS_IN_PRICE: 'order_show_bonus_in_price',

  /**
  * @summary адрес asterisk сервера
  * @description ip-адрес компьютера с asterisk
  */
  AMI_SERVER: 'ami_server',

  /**
  * @summary Asterisk Realm
  */
  ASTERISK_REALM: 'asterisk_realm',

  /**
  * @summary Адрес сервера
  * @description Используется для формирования автоматических настроек водительской программы
  */
  CONNECTION_MAIN_SERVER: 'connection_main_server',

  /**
  * @summary Обрабатывать звонки на удержании
  * @description При постановке звонка на удержание, робот сообщит автомобиль при взятии заказа водителем
  */
  ROBOT_PROCESS_WAIT: 'robot_process_wait',

  /**
  * @summary Разрешить менять свой статус занятости
  * @description При включении водитель сможет обозначить свой статус занятости
  */
  TERMINAL_CHANGESTATUS_ENABLE: 'terminal_changestatus_enable',

  /**
  * @summary Разрешить регистрироваться на стоянках
  * @description При отключении будет невозможно встать на стоянку
  */
  TERMINAL_REGISTER_ENABLE: 'terminal_register_enable',

  /**
  * @summary Разрешить авторегистрацию
  * @description Разрешить автоматическую регистрацию на стоянку (выбор стоянки будет сделан исходя из координаты водителя).
  */
  TERMINAL_AUTOREG_ENABLE: 'terminal_autoreg_enable',

  /**
  * @summary Разрешить просматривать список машин
  * @description При отключении будет невозможно просмотреть очередь на стоянке
  */
  TERMINAL_CARLIST_ENABLE: 'terminal_carlist_enable',

  /**
  * @summary Запретить отвечать на произвольные звонки
  * @description При включении можно будет ответить лишь на первый звонок из списка (отключает ответ на звонок кликом мышки)
  */
  DISP_REJECT_ANSWER_BY_CLICK: 'disp_reject_answer_by_click',

  /**
  * @summary Использовать простой таймер
  * @description Простой таймер не зависит от системного времени телефона. Но не очень точен при больших значениях времени стоянки и ожидания
  */
  TERMINAL_USE_SIMPLE_TIMER: 'terminal_use_simple_timer',

  /**
  * @summary Не отправлять биржевые заказы диспетчерам
  * @description Отключить показ заказов, принятых с биржи, в диспетчерской
  */
  EXCHANGE_NOEXCHANGEORDERS: 'exchange_noexchangeorders',

  /**
  * @summary Только шаблоны в чате
  * @description Ограничение сообщений водителей в чате только шаблонами
  */
  TERMINAL_CHAT_TEMPLATES_ONLY: 'terminal_chat_templates_only',

  /**
  * @summary Курс обмена бонусов в деньги
  * @description Количество бонусов, которое необходимодля получения 1 единицы валюты. Будет использоваться для перевода денег в бонусы, а также наоборот
  */
  DRIVER_BONUSES_EXCHANGE_RATE: 'driver_bonuses_exchange_rate',

  /**
  * @summary При поиске ближайшего выбирать среди всех подключенных
  * @description При поиске ближайшей машины будет искать среди всех подключенных машин (если выключить, поиск будет только среди зарегистрированных на стоянках)
  */
  ORDER_RADIUS_ALLDRIVERS: 'order_radius_alldrivers',

  /**
  * @summary Отправлять уведомления о новом заказе
  * @description При включении опции у водителей будет отображаться поступление нового заказа на стоянке путем короткой цветовой индикации
  */
  ORDER_SHOW_NEW: 'order_show_new',

  /**
  * @summary dest_addr_npi
  * @description возможные значения:<br/>UNKNOWN (0)<br/>ISDN (1)<br/>DATA (3)<br/>TELEX (4)<br/>LAND_MOBILE (6)<br/>NATIONAL (8)<br/>PRIVATE (9)<br/>ERMES (10)<br/>INTERNET (14)<br/>WAP_CLIENT_ID (18)
  */
  SMS_DEST_ADDR_NPI: 'sms_dest_addr_npi',

  /**
  * @summary SMPP SystemType
  * @description Параметр systemType отправляемый при подключении. Оставьте пустым если явно не указан в реквизитах подключения
  */
  SMS_SMPP_SYSTEMTYPE: 'sms_smpp_systemtype',

  /**
  * @summary Разрешить паузу в таксометре
  * @description Разрешает водителю устанавливать таксометр на паузу
  */
  TERMINAL_TAXOMETR_PAUSE: 'terminal_taxometr_pause',

  /**
  * @summary Позволить покупать бонусы за деньги
  * @description Позволяет водителю покупать его бонусы в деньги, которые зачислятся на его счет
  */
  DRIVER_BONUSES_ALLOW_BUY_BONUSES: 'driver_bonuses_allow_buy_bonuses',

  /**
  * @summary Количество дней
  * @description Количество дней, учитываемых при оценке плотности заказов
  */
  PRIORITY_PERIODS_CNT_1: 'priority_periods_cnt_1',

  /**
  * @summary В процентах
  * @description Сумма комиссии указана в процентах от взятого обещанного платежа
  */
  PROMISED_PAYMENTS_COMMISSION_IS_PERCENT: 'promised_payments_commission_is_percent',

  /**
  * @summary Разрешить брать несколько предварительных заказов
  * @description При отключенной настройке водитель сможет взять только один предварительный заказ, следующий сможет взять только при выполнении текущего
  */
  TERMINAL_NEW_RESORD_PROTOCOL: 'terminal_new_resord_protocol',

  /**
  * @summary СМС-чек
  * @description Сообщение при выполнении заказа со стоимостью
  */
  SMS_BILL_ENABLE: 'sms_bill_enable',

  /**
  * @summary Отсылать сообщение о подъезде машины
  */
  SMS_ONPLACE_ENABLE: 'sms_onplace_enable',

  /**
  * @summary Включить "Личный кабинет"
  * @description Разрешает водителю использовать личный кабинет
  */
  TERMINAL_CABINET_ENABLED: 'terminal_cabinet_enabled',

  /**
  * @summary Вес среднего чека
  * @description Влияние среднего чека клиента на его приоритет
  */
  PRIORITY_WEIGHT_AVERAGE: 'priority_weight_average',

  /**
  * @summary Вес количества заказов
  * @description Влияние общего количества заказов клиента на его приоритет
  */
  PRIORITY_WEIGHT_COUNT: 'priority_weight_count',

  /**
  * @summary Сервис уведомлений
  * @description Какой сервис использовать для отправки сообщений через мессенджеры?
  */
  MESSENGER_API: 'messenger_api',

  /**
  * @summary Шаблон сообщения с подпиской
  * @description Допустимые переменные: <br/>%url% - ссылка на страницу подписки
  */
  MESSENGER_SUBSCRIBE_MESSAGE: 'messenger_subscribe_message',

  /**
  * @summary Вес плотности заказов
  * @description Влияние плотности заказов клиента на его приоритет
  */
  PRIORITY_WEIGHT_DENSITY: 'priority_weight_density',

  /**
  * @summary Вес отмененных заказов
  * @description Влияние количества отмененных заказов с назначенным исполнителем на приоритет клиента
  */
  PRIORITY_WEIGHT_CANCELLED: 'priority_weight_cancelled',

  /**
  * @summary Приоритет заказа контрагента
  * @description Это значение прибавляется к приоритету клиента, если для заказа установлен контрагент
  */
  PRIORITY_WEIGHT_CUSTOMER: 'priority_weight_customer',

  /**
  * @summary Автоматически подписывать
  * @description СМС с предложением подписки будет отправляться автоматически клиентам, еще не подписавшимся на уведомления
  */
  MESSENGER_AUTO_SUBSCRIBE: 'messenger_auto_subscribe',

  /**
  * @summary Количество недель
  * @description Количество недель, учитываемых при оценке плотности заказов
  */
  PRIORITY_PERIODS_CNT_7: 'priority_periods_cnt_7',

  /**
  * @summary Вес первого заказа
  * @description Если номера телефона еще нет в базе данных, то к приоритету клиента прибавляется это значение
  */
  PRIORITY_WEIGHT_FIRST: 'priority_weight_first',

  /**
  * @summary Приоритет заказа диспетчера
  * @description Это значение прибавляется к приоритету клиента, если заказ принят через диспетчера
  */
  PRIORITY_WEIGHT_OPERATOR: 'priority_weight_operator',

  /**
  * @summary Вес дня рождения
  * @description Это число будет прибавлено к общему приоритету клиента в его день рождения
  */
  PRIORITY_WEIGHT_BIRTHDAY: 'priority_weight_birthday',

  /**
  * @summary Разрешить выход из таксометра во время заказа
  * @description Водитель сможет выйти из активного таксометра и взять свободный заказ "вдогонку" вручную
  */
  TERMINAL_ALLOW_LEAVE_TAXIMETER: 'terminal_allow_leave_taximeter',

  /**
  * @summary Разрешить работу без GPS
  * @description При включении данной настройки, водитель сможет работать с терминалом без включения GPS
  */
  TERMINAL_ALLOW_NO_GPS: 'terminal_allow_no_gps',

  /**
  * @summary Включить рейтинг водителей
  * @description Включить подсчет рейтинга водителей
  */
  DRIVER_RATING_ENABLED: 'driver_rating_enabled',

  /**
  * @summary Порог блокировки
  * @description Рейтинг, при достижении которого водитель будет заблокирован
  */
  DRIVER_RATING_BLOCK_RATING_LEVEL: 'driver_rating_block_rating_level',

  /**
  * @summary Запрашивать подтверждение у водителя
  * @description Запрашивать за определенное время у водителя подтверждение что он поедет на заказ
  */
  RESERV_ORDERS_CFRM_ENABLE: 'reserv_orders_cfrm_enable',

  /**
  * @summary Разрешить нулевую стоимость
  * @description Допускается цена заказа = 0, иначе при нулевой стоимости запустится таксометр
  */
  ORDER_ALLOW_ZERO_AMOUNT: 'order_allow_zero_amount',

  /**
  * @summary Оповещать водителя о предварительном заказе (мин)
  * @description Отправлять push-уведомление на терминал водители за указанное время до начала заказа. Для нескольуих уведомлений указать время через запятую без пробелов. Например "60,30,15" - за 60 минут, за 30 и за 15
  */
  RESERV_ORDERS_NOTIFICATION_STEPS: 'reserv_orders_notification_steps',

  /**
  * @summary Максимальная наценка при нагрузке
  * @description При недостатке свободных водителей для выполнения заказов, на новые заказы будет добавляться наценка не более этой. Размер наценки определяется в зависимости от кол-ва свободных заказов и водителей. Установите равным 0, чтобы отключить эту функцию
  */
  MAX_LOAD_MARKUP: 'max_load_markup',

  /**
  * @summary Автоматически включать ожидание
  * @description Автоматически включать счетчик ожидания по истечению бесплатного времени ожидания
  */
  TERMINAL_WAIT_AUTOSTART: 'terminal_wait_autostart',

  /**
  * @summary Конечная дата периода
  * @description Дата окончания подсчета заказов
  */
  VMIG_RATING_END_DATE: 'vmig_rating_end_date',

  /**
  * @summary Режим мультисчетчика
  * @description Производить расчет стоимости по каждому тарифу отдельно.
  */
  TERMINAL_TAXOMETR_MULTI: 'terminal_taxometr_multi',

  /**
  * @summary Минимальная версия для Windows Mobile
  * @description Минимально допустимая версия ПО для коммуникаторов на базе Windows Mobile
  */
  SOFT_MINVERSION_WM: 'soft_minversion_wm',

  /**
  * @summary КитИнвест CompanyId
  * @description выдается при подключении к сервису
  */
  CHECK_KITINVEST_COMPANY_ID: 'check_kitinvest_company_id',

  /**
  * @summary Временной штамп тарифов
  */
  RATES_TIMESTAMP: 'rates_timestamp',

  /**
  * @summary Максимальная версия для Android
  * @description Максимально допустимая версия ПО для android терминалов
  */
  SOFT_MAXVERSION_ANDROID: 'soft_maxversion_android',

  /**
  * @summary Сохранять позицию при смене стоянки
  * @description При включенной авторегистрации при смене стоянки (перезде в другую) позиция будет расчитана исходя из времени регистрации на стоянке
  */
  AUTOREG_KEEP_REGTIME: 'autoreg_keep_regtime',

  /**
  * @summary Запрашивать способ оплаты
  * @description При наличии терминала для приема банковских карт нужно включить, чтобы у водителя была возможность выбрать способ оплаты. По умолчанию подразумевается, что оплата производится наличными
  */
  TERMINAL_ASK_PAY_METHOD: 'terminal_ask_pay_method',

  /**
  * @summary КитИнвест Система налогообложения
  */
  CHECK_KITINVEST_TAX_SYSTEM_TYPE: 'check_kitinvest_tax_system_type',

  /**
  * @summary Не отключать робота при вмешательстве диспетчера
  * @description При включении даже если клиент перезвонит или позвонит диспетчер - робот все равно будет пытаться звонить
  */
  ROBOT_DONT_DISABLE_ROBOT: 'robot_dont_disable_robot',

  /**
  * @summary Ключ шифрования sip-паролей
  * @description Оставьте пустым для автоматической генерации
  */
  SIP_SECURITY_KEY: 'sip_security_key',

  /**
  * @summary Убирать со стоянок при потере связи
  * @description Убирать водителя со стоянок при потере связи. После окончания время жизни сессии водителя уберет со стоянок при отсутствии активности.
  */
  KICK_WHEN_DISCONNECT: 'kick_when_disconnect',

  /**
  * @summary Наименование товара в чеке
  */
  CHECK_PRODUCT_NAME: 'check_product_name',

  /**
  * @summary Идентификатор клиента Яндекс
  * @description Требуется для запуска Яндекс.Навигатор из программы водителя. Выдается вместе с ключом
  */
  TERMINAL_YANDEX_CLIENTID: 'terminal_yandex_clientid',

  /**
  * @summary КитИнвест Ставка НДС
  */
  CHECK_KITINVEST_TAX: 'check_kitinvest_tax',

  /**
  * @summary Помечать для водителей висячие заказы
  * @description Если включена то в водители будут видеть иконку висячего заказа в списке свободных
  */
  ORDER_MARKREJECT_SHOW_DRIVER: 'order_markreject_show_driver',

  /**
  * @summary Показывать приоритет водителя
  * @description Позволяет водителю видеть свой приоритет в мобильном приложении
  */
  TERMINAL_SHOWPRIORITY: 'terminal_showpriority',

  /**
  * @summary Использовать одну сумму заказа
  * @description При включении данной настройки, стоимость заказа для контрагента всегда будет принята равной стоимости заказа для водителя.
  */
  OPERATOR_USE_SINGLE_PRICE: 'operator_use_single_price',

  /**
  * @summary Порт тарифного сервера
  */
  OPERATOR_RATE_SERVER_PORT: 'operator_rate_server_port',

  /**
  * @summary Порт сервера телефонии
  */
  OPERATOR_SIP_PORT: 'operator_sip_port',

  /**
  * @summary Количество попыток дозвониться
  * @description если не удалось дозвониться это количество раз статус измениться
  */
  ROBOT_DIAL_COUNT: 'robot_dial_count',

  /**
  * @summary Пауза между попытками
  * @description сколько секунд ждать между очередной попыткой дозвониться
  */
  ROBOT_DIAL_PAUSE: 'robot_dial_pause',

  /**
  * @summary Количество предложений подождать еще
  * @description Система будет предлагать подождать машину еще 5 минут данное количество раз, после этого будет сообщение "Извините мы не можем предоставить автомобиль"
  */
  ROBOT_REJECT_COUNT: 'robot_reject_count',

  /**
  * @summary КитИнвест Адрес организации
  * @description адрес организации (будет зафиксирован в чеке)
  */
  CHECK_KITINVEST_ADDRESS: 'check_kitinvest_address',

  /**
  * @summary КитИнвест Login
  * @description выдается при подключении к сервису
  */
  CHECK_KITINVEST_LOGIN: 'check_kitinvest_login',

  /**
  * @summary КитИнвест Password
  * @description выдается при подключении к сервису
  */
  CHECK_KITINVEST_PASSWORD: 'check_kitinvest_password',

  /**
  * @summary Адрес тарифного сервера
  */
  OPERATOR_RATE_SERVER_HOST: 'operator_rate_server_host',

  /**
  * @summary Адрес сервера СКАТ для подключения диспетчерской панели
  */
  OPERATOR_SERVER_HOST: 'operator_server_host',

  /**
  * @summary Сервер телефонии
  * @description Адрес сервера телефонии
  */
  OPERATOR_SIP_HOST: 'operator_sip_host',

  /**
  * @summary Автоматическая фискализация
  * @description При включении фискализация производится сразу после завершения поездки водителем без дополнительных действий с его стороны
  */
  TERMINAL_AUTO_CHECK: 'terminal_auto_check',

  /**
  * @summary Включить фискализацию для безналичных оплат
  * @description Позволяет водителю зарегистрировать чек даже если заказ оплачивается безналичным способом
  */
  TERMINAL_CHECK_ENABLE_ON_NONCASH: 'terminal_check_enable_on_noncash',

  /**
  * @summary Настройки сервиса уведомлений
  * @description Настройки сервиса уведомлений. Зависят от используемого сервиса.
  */
  MESSENGER_SETTINGS: 'messenger_settings',

  /**
  * @summary Отправлять сообщение о машине
  */
  SMS_CFRM_ENABLE: 'sms_cfrm_enable',

  /**
  * @summary Время жизни сессии (мин.)
  * @description В течении этого времени водитель будет оставаться на отметке если проблемы со связью или терминалом
  */
  SESSION_LIVETIME: 'session_livetime',

  /**
  * @summary Геокодинг
  * @description Сервис преобразования адресов в координаты
  */
  GEO_CODING: 'geo_coding',

  /**
  * @summary Порог времени
  * @description За сколько минут заказ переходит в разряд обычных заказов
  */
  RESERV_ORDERS_TIMELIMIT: 'reserv_orders_timelimit',

  /**
  * @summary Порт для AMI
  * @description Порт для управления потоками звонков от asterisk для диспетчерской
  */
  AMI_PORT: 'ami_port',

  /**
  * @summary Оповещать водителя о начале его смены по графику
  * @description Отправлять push-уведомление на терминал водителя за указанное время до начала времени работы. Для нескольких уведомлений указать время через запятую без пробелов. Например "60,30,15" - за 60 минут, за 30 и за 15
  */
  SCHEDULE_NOTIFICATION_STEPS: 'schedule_notification_steps',

  /**
  * @summary Отсылать сообщение на предварительные заказы
  * @description Если активировано будет высылаться сообщение когда заказ закрепляется за водителем
  */
  SMS_RESERV_ENABLE: 'sms_reserv_enable',

  /**
  * @summary Подложка карты
  * @description Сервис для отрисовки гео-данных
  */
  GEO_TILES: 'geo_tiles',

  /**
  * @summary Прокладка маршрута
  * @description Сервис для прокладки маршрута
  */
  GEO_ROUTING: 'geo_routing',

  /**
  * @summary Максимальная сумма
  * @description Ограничивает сумму обещанного платежа не более указанной
  */
  PROMISED_PAYMENTS_MAX_AMOUNT: 'promised_payments_max_amount',

  /**
  * @summary Сумма комиссии
  * @description Сумма комиссии, добавляемая к задолженности водителя
  */
  PROMISED_PAYMENTS_COMMISSION_AMOUNT: 'promised_payments_commission_amount',

  /**
  * @summary Стартовый рейтинг
  * @description Рейтинг водителя, не имеющего оценок
  */
  DRIVER_RATING_DEFAULT_DRIVER_RATING: 'driver_rating_default_driver_rating',

  /**
  * @summary Уменьшение плотности заказов со временем
  * @description Плотность заказов клиента снижается на это значение за каждые сутки без заказа
  */
  PRIORITY_DENSITY_DECAY: 'priority_density_decay',

  /**
  * @summary Включить биллинг
  * @description Включить автоматический учет баланса водителей
  */
  BILLING_ENABLED: 'billing_enabled',

  /**
  * @summary Адрес сервера с сайтом
  * @description Заказы будут приниматься только с этого хоста
  */
  EXTORDER_WEB_HOST: 'extorder_web_host',

  /**
  * @summary Включить интеграцию с NOWTAXI
  */
  NOWTAXI_ENABLED: 'nowtaxi_enabled',

  /**
  * @summary идентификатор службы NOWTAXI
  * @description Выдается при подключении
  */
  NOWTAXI_SERVICE_ID: 'nowtaxi_service_id',

  /**
  * @summary API ключ NOWTAXI
  * @description Выдается при подключении
  */
  NOWTAXI_APIKEY: 'nowtaxi_apikey',

  /**
  * @summary SMPP порт
  * @description порт подключения
  */
  SMS_SMPP_PORT: 'sms_smpp_port',

  /**
  * @summary Не звонить
  * @description Не звонить если есть возможность отправить СМС
  */
  SMS_NOTDIAL: 'sms_notdial',

  /**
  * @summary Менять статус заказа
  * @description Менять статус заказа при получении уведомления о доставке
  */
  SMS_CHANGE_STATUS: 'sms_change_status',

  /**
  * @summary Адрес отправителя
  */
  SMS_FROM_ADDR: 'sms_from_addr',

  /**
  * @summary Подтверждение на завершение заявки
  * @description Заказ закрывается только после подтверждения диспетчером
  */
  ORDER_COMPLITECONFIRM: 'order_compliteconfirm',

  /**
  * @summary Распределение заказов
  * @description Первая цифра заказы на терминалы, вторая на рации. Или поставтье 0 для отключения распределения
  */
  ORDER_SPLIT: 'order_split',

  /**
  * @summary Количество заказов для автозаказа
  * @description количество выполненных заказов, после которых станет доступным автозаказ
  */
  ROBOT_REGULAR_MINIMUM: 'robot_regular_minimum',

  /**
  * @summary Помещать стоимость поездки в сообщение о подъезде
  * @description Отправлять стоимость поездки в сообщении о подъезде авто, если она известна
  */
  SMS_ONPLACEBILL_ENABLE: 'sms_onplacebill_enable',

  /**
  * @summary Максимально разрешенное время подъезда
  * @description Интервал времени в минутах на который сервер отреагирует при подъезде водителя. Если водитель подъедет раньше этого интервала - сервер проигнорирует. 0 - отключить
  */
  RESERV_ONPLACE_LIMIT: 'reserv_onplace_limit',

  /**
  * @summary Автоматически подтверждать НА МЕСТЕ
  * @description Автоматически считать, что клиент уведомлен о том, что водитель подъехал по адресу. Таймер начнет считать сразу после нажатия на кнопку "На месте"
  */
  ORDER_AUTOONPLACECONFIRM: 'order_autoonplaceconfirm',

  /**
  * @summary Уведомления о новом заказе за пределы очереди
  * @description При включении опции уведомление о новом заказе будет отправлено во все очереди, в которые может попасть определенный заказ
  */
  ORDER_SHOW_NEW_OTHER: 'order_show_new_other',

  /**
  * @summary Пауза между предложениями подождать еще
  * @description в секундах. Время до следующей попытки предложить подождать еще или до отказа, если попытки закончились
  */
  ROBOT_WAIT_LONGER_TIMER: 'robot_wait_longer_timer',

  /**
  * @summary Интервал отсылки GPS
  * @description через сколько секунд отсылать координаты на сервер
  */
  TERMINAL_GPS_INTERVAL: 'terminal_gps_interval',

  /**
  * @summary Принимать стоимость поездки от водителя
  * @description Если опция не активирована, то стоимость на заказе может установить только диспетчер
  */
  ORDER_RECIEVEPRICE: 'order_recieveprice',

  /**
  * @summary Автообновление свободных заказов в реальном времени
  * @description Автоматически обновлять свободные. Доступно с версии 0.7.1. Внимание! не используйте вместе с автообновлением по таймеру. При большом количестве свободных заказов будет нагружать сервер
  */
  TERMINAL_FO_AUTOUPDATE: 'terminal_fo_autoupdate',

  /**
  * @summary Использовать hash пароля
  * @description Отправлять пароль в виде хеша
  */
  CONNECTION_USE_HASHPASSWORD: 'connection_use_hashpassword',

  /**
  * @summary Идентификатор Qiwi терминала
  * @description Выдается при регистрации (поставьте 0 для отключения)
  */
  BILLING_QIWI_ID: 'billing_qiwi_id',

  /**
  * @summary Интервал ping
  * @description через сколько секунд отсылать пинг на сервер
  */
  TERMINAL_PING_INTERVAL: 'terminal_ping_interval',

  /**
  * @summary Шаблон сообщения на предварительном заказе
  * @description допустимые переменн<br/>%car% - марка автомобиля<br/>%color% - цвет автомобиля<br/>%number% - гос.номер автомобиля<br/>%cost% - Стоимость
  */
  SMS_RESERV_TEMPLATE: 'sms_reserv_template',

  /**
  * @summary Отсылать все свободные
  * @description При запросе свободных заказов с любого района отсылать следом свободные с других районов
  */
  ORDER_ALL_FREEORDERS: 'order_all_freeorders',

  /**
  * @summary Заголовок прямого заказа
  * @description Как обозначать адрес при прямом заказе
  */
  DIRECT_ORDER_TITLE: 'direct_order_title',

  /**
  * @summary Свободные только зарегистрированным
  * @description Если включена то свободный заказ смогут взять только водители, которые зарегистрированы на стоянке
  */
  ORDER_FREEONLYFORREG: 'order_freeonlyforreg',

  /**
  * @summary Разрешить соединение с водителем
  * @description Разрешает при сообщении автомобиля выбрать пункт соединения с водителем
  */
  ROBOT_DRIVERCONNECT_ENABLE: 'robot_driverconnect_enable',

  /**
  * @summary Запретить ручной отказ
  * @description запрещает диспетчеру делать отзвон об отсутствии машин вручную
  */
  DIALOUT_REJECT_ENABLE: 'dialout_reject_enable',

  /**
  * @summary Сообщать автомобиль при входящем звонке
  * @description Если за номером закреплен заказ, то автоматически сообщить данный автомобиль
  */
  ROBOT_INFO_INCOMING: 'robot_info_incoming',

  /**
  * @summary Включить автозаказ для стационарных телефонов
  * @description возможность заказать автомобиль без участия диспетчера
  */
  ROBOT_REGULAR_ENABLE: 'robot_regular_enable',

  /**
  * @summary Отправлять номер телефона клиента водителю вместе с заказом
  */
  SEND_CLIENT_PHONE: 'send_client_phone',

  /**
  * @summary Отсылать службу
  * @description Показывать водителю, от какой службы заказ
  */
  ORDER_SEND_SERVICE: 'order_send_service',

  /**
  * @summary Включить сообщения
  * @description Позволяет водителям отправлять сообщения
  */
  CHAT_ENABLE: 'chat_enable',

  /**
  * @summary Включить сообщения между водителями
  * @description Позволяет водителям отправлять сообщения друг другу.<br/>Если опция выключена, водители смогут отправлять сообщения только диспетчеру
  */
  CHAT_DRIVER_ENABLE: 'chat_driver_enable',

  /**
  * @summary Включить обратный звонок клиенту (бумеранг)
  * @description Если клиент позвонил и положил сразу трубку, система автоматически перезвонит
  */
  CALLBACK_ENABLE: 'callback_enable',

  /**
  * @summary Таймаут отправки свободных заказов
  * @description Таймаут(в секундах), после которого, свободный заказ автоматически отправится на биржу
  */
  EXCHANGE_FREEORDERPASSTIMEOUT: 'exchange_freeorderpasstimeout',

  /**
  * @summary Обрабатывать свободный заказ при входящем звонке
  * @description Если за номером закреплен свободный заказ, сообщить что в данный момент ищется автомобиль и предложить подождать еще с возможностью отказа и соединения с диспетчером
  */
  ROBOT_FREE_INCOMING: 'robot_free_incoming',

  /**
  * @summary Выбирать ближайшего водителя
  * @description Система будет выбирать ближайшего водителя к адресу заказа
  */
  RADIUS_ENABLE: 'radius_enable',

  /**
  * @summary Включить робота
  * @description включить автоматический отзвон клиентам
  */
  ROBOT_ENABLE: 'robot_enable',

  /**
  * @summary Включить сортировку по приоритетам
  * @description Если включена, при выборе водителя будет учитываться приоритет
  */
  ORDER_DRIVER_PRIORITY_ENABLE: 'order_driver_priority_enable',

  /**
  * @summary Порт для AGI
  * @description порт для управление звонком от asterisk для автоинформатора
  */
  AGI_PORT: 'agi_port',

  /**
  * @summary Расчетный день месяца (число)
  * @description В этот день будет производится списание стоимости месяца у водителей
  */
  BILLING_STARTMDAY: 'billing_startmday',

  /**
  * @summary Минимальная версия для Android
  * @description Минимально допустимая версия ПО для android терминалов
  */
  SOFT_MINVERSION_ANDROID: 'soft_minversion_android',

  /**
  * @summary Количество попыток запроса подтверждения
  * @description сколько раз пытаться запросить подтверждение у водителя
  */
  RESERV_ORDERS_CFRM_COUNT: 'reserv_orders_cfrm_count',

  /**
  * @summary Звонить контрагентам
  * @description Если включить робот будет звонить контрагентам, в ином случае, звонить необходимо будет самостоятельно
  */
  ROBOT_CUSTOMER_ENABLE: 'robot_customer_enable',

  /**
  * @summary
  */
  BILLING_YM_CLIENT_ID: 'billing_ym_client_id',

  /**
  * @summary
  */
  BILLING_YM_PERMANENT_TOKEN: 'billing_ym_permanent_token',

  /**
  * @summary Минимальная версия для Java
  * @description Минимально допустимая версия ПО для java терминалов
  */
  SOFT_MINVERSION_JAVA: 'soft_minversion_java',

  /**
  * @summary Пароль Qiwi
  * @description Выдается при регистрации
  */
  BILLING_QIWI_PASSWORD: 'billing_qiwi_password',

  /**
  * @summary SMPP логин
  * @description логин для подключения к smpp серверу
  */
  SMS_SMPP_LOGIN: 'sms_smpp_login',

  /**
  * @summary SMPP пароль
  * @description пароль для подключения к smpp серверу
  */
  SMS_SMPP_PASSWORD: 'sms_smpp_password',

  /**
  * @summary Резервный адрес сервера
  * @description Используется для формирования автоматических настроек водительской программы
  */
  CONNECTION_RESERV_SERVER: 'connection_reserv_server',

  /**
  * @summary Скрыть настройки у водителя
  * @description Убирать настройки подключения на экране водителя (только при автоматической настройке)
  */
  CONNECTION_HIDE_SETTINGS: 'connection_hide_settings',

  /**
  * @summary Время блокировки при отказе
  * @description На сколько минут блокировать водителя при отказе или игнорировании (Поставьте 0 для отключения блокировки)
  */
  RESERV_ORDERS_BAN: 'reserv_orders_ban',

  /**
  * @summary День начала расчетной недели
  * @description 1 - Понедельник<br/>2 - Вторник<br/>3 - Среда<br/>4 - Четверг<br/>5 - Пятница<br/>6 - Суббота<br/>7 - Воскресение
  */
  BILLING_STARTDAY: 'billing_startday',

  /**
  * @summary Сброс счетчика выполненных заказов
  * @description Для расчета стоимости по диапозону<br/>1 - ежедневно в час начала расчетных суток<br/>2 - еженедельно в день начала расчетной недели в час начала расчетных суток
  */
  BILLING_COUNTERRESET: 'billing_counterreset',

  /**
  * @summary IP адреса СберБанк
  * @description Адреса разделенные запятыми, с которых разрешено принимать запросы
  */
  BILLING_SB_IP: 'billing_sb_ip',

  /**
  * @summary Резервный порт
  * @description Основной порт для подключения водителей
  */
  CONNECTION_RESERV_PORT: 'connection_reserv_port',

  /**
  * @summary Длительность штрафа
  * @description Количество дней, в течение которых водитель не сможет брать обещанные платежи после просрочки.<br>0 - для неограниченного времени
  */
  PROMISED_PAYMENTS_MULCT_LENGTH: 'promised_payments_mulct_length',

  /**
  * @summary API-ключ Kavenegar
  * @description API-ключ сервиса отправки СМС Kavenegar
  */
  SMS_API_KAVENEGAR_KEY: 'sms_api_kavenegar_key',

  /**
  * @summary Запрещенные приложения
  * @description Введите через запятую список запрещенных программ у водителя. В случае обнаружения любой программы из списка - приложение водителя не запустится, показав предупреждающее окно. Например: com.supertaxi
  */
  TERMINAL_BANNEDAPPS: 'terminal_bannedapps',

  /**
  * @summary Комисия при оплате через внешние терминалы
  * @description Комиссия при зачислении на счет водителя в процентах
  */
  BILLING_EXTERNAL_MARGIN: 'billing_external_margin',

  /**
  * @summary Не показывать цену до принятия решения
  * @description Стоимость заказа отобразиться только после установки времени водителем
  */
  TERMINAL_HIDE_PRICE: 'terminal_hide_price',

  /**
  * @summary Сервер биржи
  * @description Адрес сервера обмена заказами
  */
  EXCHANGE_SERVER: 'exchange_server',

  /**
  * @summary Ключ доступа
  * @description Уникальный ключ для доступа данного сервера к бирже
  */
  EXCHANGE_KEY: 'exchange_key',

  /**
  * @summary Отправлять свободные заказы автоматически
  * @description Автоматически отсылать заказ свободный заказ на биржу с установленным таймаутом
  */
  EXCHANGE_AUTOPASSTOEXCHANGE: 'exchange_autopasstoexchange',

  /**
  * @summary Просмотр свободных только зарегистрированным
  * @description Разрешить просматривать список свободных заказов только зарегистрированным на стоянке водителям
  */
  ORDER_VIEWFREEONLYFORREG: 'order_viewfreeonlyforreg',

  /**
  * @summary Удалять переданные на биржу заказы из свободных
  * @description После передачи заказа на бирже, он будет удален из списка свободных заказов
  */
  EXCHANGE_REMOVEFROMFREE: 'exchange_removefromfree',

  /**
  * @summary Свободные заказы в новом формате
  * @description отправлять свободные заказы в новом формате. Необходимо для сортировки заказов по расстояния до них. Доступно с версии 0.7.1
  */
  TERMINAL_NEW_FO_FORMAT: 'terminal_new_fo_format',

  /**
  * @summary Отменять заказ если клиент не дождался сообщения на удержании
  * @description Отменит заказ если клиент при ожидании сообщения авто на удержании положит трубку
  */
  ROBOT_CANCEL_ON_LEAVE: 'robot_cancel_on_leave',

  /**
  * @summary Запрашивать открытие смены
  * @description При предоплатном тарифе у водителя запрашивать открытие смены (списание стоимости смены)
  */
  CONNECTION_REQUEST_SESSION_INIT: 'connection_request_session_init',

  /**
  * @summary Считать расстояния на малых скоростях
  * @description Считать расстояние на скорости меньше стояночного порога (Только при ручном управлении режимом стоянки)
  */
  TERMINAL_TAXOMETR_CALC_SLOW: 'terminal_taxometr_calc_slow',

  /**
  * @summary Включить обещанные платежи
  * @description Включает возможность брать обещанные платежи для водителей
  */
  TERMINAL_PROMISED_PAYMENTS_ACTIVE: 'terminal_promised_payments_active',

  /**
  * @summary Включить штрафы
  * @description Лишает водителя брать повторные обещанные платежи в случае просрочки
  */
  PROMISED_PAYMENTS_MULCT_ACTIVE: 'promised_payments_mulct_active',

  /**
  * @summary Порт для уведомлений
  * @description Порт на этом сервере, на который биржа будет присылать уведомления о событиях
  */
  EXCHANGE_LISTENPORT: 'exchange_listenport',

  /**
  * @summary Включить интеграцию с биржей
  * @description Разрешить вашему серверу обмениваться заказами с биржей
  */
  EXCHANGE_ENABLED: 'exchange_enabled',

  /**
  * @summary Учитывать стоянку на фиксированной стоимости
  * @description Разрешить водителю включать стоянку на фиксированном тарифе
  */
  TERMINAL_TAXOMETR_FIX_STAND: 'terminal_taxometr_fix_stand',

  /**
  * @summary Не передавать заказы с балами
  * @description Если включить, заказы с бонусами не будут автоматически копироваться в другие очереди
  */
  ORDER_DONTCOPYBONUS: 'order_dontcopybonus',

  /**
  * @summary Принимать сигнал тревоги
  * @description При отключении сигнал тревоги будет игнорироваться
  */
  TERMINAL_ALERT_ENABLE: 'terminal_alert_enable',

  /**
  * @summary Альфабанк комиссия
  * @description Комиссия при зачислении денег на счет водителя
  */
  BILLING_CARDPAY_MARGIN: 'billing_cardpay_margin',

  /**
  * @summary Проверять стоянку при регистрации
  * @description Запретить регистрацию на стоянке, если водитель находится за пределами границы.
  */
  TERMINAL_CHECK_COORD_ON_REG: 'terminal_check_coord_on_reg',

  /**
  * @summary Максимальная версия для Java
  * @description Максимально допустимая версия ПО для java терминалов
  */
  SOFT_MAXVERSION_JAVA: 'soft_maxversion_java',

  /**
  * @summary source_addr_npi
  * @description возможные значения:<br/>UNKNOWN (0)<br/>ISDN (1)<br/>DATA (3)<br/>TELEX (4)<br/>LAND_MOBILE (6)<br/>NATIONAL (8)<br/>PRIVATE (9)<br/>ERMES (10)<br/>INTERNET (14)<br/>WAP_CLIENT_ID (18)
  */
  SMS_SOURCE_ADDR_NPI: 'sms_source_addr_npi',

  /**
  * @summary source_addr_ton
  * @description возможные значения (в скобках цифровое значение параметра):<br/>UNKNOWN (0)<br/>INTERNATIONAL (1)<br/>NATIONAL (2)<br/>NETWORK_SPECIFIC (3)<br/>SUBSCRIBER_NUMBER (4)<br/>ALPHANUMERIC (5)<br/>ABBREVIATED (6)
  */
  SMS_SOURCE_ADDR_TON: 'sms_source_addr_ton',

  /**
  * @summary Создавать биржевые заказы как свободные
  * @description Биржевые заказы сразу добавляются в свободные, а не в очередь
  */
  EXCHANGE_NOQUEUEORDER: 'exchange_noqueueorder',

  /**
  * @summary Отменять заказ при недозвоне
  * @description Если робот не дозвонится до клиента с сообщением что нет машин автоматически отменить заказ
  */
  ROBOT_REJECT_CANCEL_NOTDIAL: 'robot_reject_cancel_notdial',

  /**
  * @summary Время запрета отзвона
  * @description Час начала действия запрета отзвона с сообщением машины и через запятую конец (Например 22,7 - с 22 до 7 утра отзвонов не будет)<br/>Если ограничение не нужно, поставьте 0 или оставьте пустым
  */
  RESERV_TIMELIMIT: 'reserv_timelimit',

  /**
  * @summary Запретить изменять настройки подтверждения действий
  * @description При включении водитель не сможет изменить у себя настройки на подтверждения действий (запуск и остановка таксометра, установка времени
  */
  TERMINAL_HIDE_CONFIRMSETTINGS: 'terminal_hide_confirmsettings',

  /**
  * @summary Скрыть завершенные заказы в диспетчерской
  * @description Запретить просмотр завершенных заказов в диспетчерской
  */
  ORDER_HIDE_COMPLETED: 'order_hide_completed',

  /**
  * @summary 5-бальная система оценки
  * @description Если включено, клиенты будут выбирать 1-5 звезд, иначе "Понравилось"/"Не понравилось"
  */
  DRIVER_RATING_VOTE5: 'driver_rating_vote5',

  /**
  * @summary Пауза автоответа
  * @description Пауза в миллисекундах перед повторной регистрации агента в очереди обработки вызова (через сколько после закрытия карточки заказа будет возможность вновь принимать звонки)
  */
  AGENT_REGISTER_PAUSE: 'agent_register_pause',

  /**
  * @summary Отправлять состояния водителей на биржу
  * @description При включении данной опции состояния и координаты водителей будут передаваться на биржу
  */
  EXCHANGE_SEND_DRIVERS: 'exchange_send_drivers',

  /**
  * @summary API ключ Яндекс
  * @description Требуется для запуска Яндекс.Навигатор из программы водителя. Получить ключ можно здесь: https://yandex.ru/set/lp/navigatorb2b/0/#form
  */
  TERMINAL_YANDEX_KEY: 'terminal_yandex_key',

  /**
  * @summary Использовать транслит
  * @description Переводить все нелатинские символы при помощи транслита
  */
  SMS_USE_TRANSLIT: 'sms_use_translit',

  /**
  * @summary Использовать кеширующий гео-сервер
  * @description Получать данные от внешнего сервиса
  */
  USE_GEOCENTER: 'use_geocenter',

  /**
  * @summary Включить заказы вдогонку
  * @description Включить модуль "Заказы вдогонку"
  */
  ENABLE_ORDER_ON_THE_RUN: 'enable_order_on_the_run',

  /**
  * @summary Радиус предложения (м.)
  * @description Дистанция (в метрах) до конечной точки, с которой, начинается предложение заказов
  */
  SUGGEST_DISTANCE: 'suggest_distance',

  /**
  * @summary Предлагать не чаще чем (мин.)
  * @description Как часто (в минутах) отправлять уведомления водителю о новых заказах, если заказов несколько.
  */
  SUGGEST_TIMEOUT_MIN: 'suggest_timeout_min',

  /**
  * @summary Ограничение по кол-ву
  * @description Максимальное кол-во заказов, которые могут быть предложены одновременно
  */
  MAX_BINDINGS_PER_DRIVER: 'max_bindings_per_driver',

  /**
  * @summary Обрабатывать все заказы
  * @description Разрешить уведомлять водителей даже если на заказах нет адреса назначения (не рекомендуется).
  */
  HANDLE_ORDERS_WITHOUT_DESTINATION: 'handle_orders_without_destination',

  /**
  * @summary Инвертировать список свободных заказов
  * @description Вверху списка будут последние поступившие заказы
  */
  ORDER_FREEORDER_REVERS: 'order_freeorder_revers',

  /**
  * @summary Определять местоположения по сетям
  * @description При определении местоположения водителя будут учитываться координаты, полученные по сотовым и wifi сетям (только при отсутствии сигнала GPS). На работу таксометра эти координаты влиять не будут
  */
  TERMINAL_USE_NETWORK_LOCATION: 'terminal_use_network_location',

  /**
  * @summary Разрешить отказываться от заказа после взятия
  * @description При установке опции водителю будет доступен отказ от заказа даже после того, как он возьмет заказ (поставит время подъезда). Статус заказа изменится на \"Водитель отказался\" и дальнейшую судьбу заказа будет решать диспетчер
  */
  TERMINAL_ALLOW_REJECT: 'terminal_allow_reject',

  /**
  * @summary Включить учет самостоятельных заказов
  * @description Позволяет вести учет заказов, которые водитель выполнял самостоятельно (без участия диспетчерской)
  */
  TERMINAL_SELFORDER_ENABLE: 'terminal_selforder_enable',

  /**
  * @summary Частота проверки координат (мин.)
  * @description Как часто (в минутах) проверять gps координаты водителей (каждая проверка - нагрузка на сервер, поэтому это время регулируется)
  */
  GPS_CHECK_INTERVAL_MIN: 'gps_check_interval_min',

  /**
  * @summary Позволить выводить бонусы в деньги
  * @description Позволяет водителю переводить его бонусы в деньги, которые зачислятся на его счет
  */
  DRIVER_BONUSES_ALLOW_WITHDRAW: 'driver_bonuses_allow_withdraw',

  /**
  * @summary Включить комиссию
  * @description Увеличивает сумму задолженности водителя после завершения обещанного платежа
  */
  PROMISED_PAYMENTS_COMMISSION_ENABLED: 'promised_payments_commission_enabled',

  /**
  * @summary В день
  * @description Сумма комиссии умножается на количество дней, на которое взят обещанный платёж
  */
  PROMISED_PAYMENTS_COMMISSION_IS_PER_DAY: 'promised_payments_commission_is_per_day',

  /**
  * @summary Включить бонусы водителей
  * @description Будет применено только после перезагрузки сервера
  */
  DRIVER_BONUSES_ACTIVE: 'driver_bonuses_active',

  /**
  * @summary Максимальная дистанция до след. заказа (м.)
  * @description Максимальная дистанция от водителя до следующего заказа. Заказы дальше указанной дистанции - предлагаться не будут
  */
  NEXT_ORDER_DISTANCE_LIMIT: 'next_order_distance_limit',

  /**
  * @summary Перемещать в конец очереди при отказе
  * @description Вместо блокировки перемещать в конец очереди после отказа или игнорировании заказа
  */
  ORDER_RESET_REG_REJECT: 'order_reset_reg_reject',

  /**
  * @summary Сортировать список свободных заказов по приоритету клиента
  * @description Наиболее приоритетные будут вверху списка
  */
  ORDER_FREEORDER_PRIORITY_SORT: 'order_freeorder_priority_sort',

  /**
  * @summary Блокировать при отказе в радиусе поиска
  * @description Блокировать водителя даже если заказ пришел ему на соседнюю стоянку по радиусу
  */
  BAN_RADIUS: 'ban_radius',

  /**
  * @summary Отменять заказ при отказе через IVR
  * @description Отменять заказ сразу после нажатия 0 в голосовом меню при сообщении автомобиля, иначе будет ставиться статус о том что клиент отказался от заказа и решение будет принимать диспетчер
  */
  ROBOT_IVR_REJECT_WO_MODERATION: 'robot_ivr_reject_wo_moderation',

  /**
  * @summary Включить приоритеты клиентов
  * @description Включить определение приоритетных клиентов
  */
  PRIORITY_ENABLED: 'priority_enabled',

  /**
  * @summary Проверять обновления при запуске
  * @description При запуске программы проверять обновления на сервере.
  */
  TERMINAL_AUTO_UPDATE: 'terminal_auto_update',

  /**
  * @summary Функция(средний чек)
  * @description Функция нормализации среднего чека
  */
  PRIORITY_FUNC_AVERAGE: 'priority_func_average',

  /**
  * @summary Параметры функции(средний чек)
  * @description Параметры функция нормализации среднего чека. Список параметров зависит от типа функции
  */
  PRIORITY_FUNC_AVERAGE_PARAMS: 'priority_func_average_params',

  /**
  * @summary Функция(количество)
  * @description Функция нормализации общего количества заказов
  */
  PRIORITY_FUNC_COUNT: 'priority_func_count',

  /**
  * @summary Параметры функции(количество)
  * @description Параметры функция нормализации общего количества заказов. Список параметров зависит от типа функции
  */
  PRIORITY_FUNC_COUNT_PARAMS: 'priority_func_count_params',

  /**
  * @summary Функция(плотность заказов)
  * @description Функция нормализации плотности заказов
  */
  PRIORITY_FUNC_DENSITY: 'priority_func_density',

  /**
  * @summary Разрешить отказываться на входящих
  * @description Разрешить отказываться от заказа путем нажатия на 0 при обработке входящего звонка
  */
  ROBOT_ALLOW_REJECT_ON_INCOMING: 'robot_allow_reject_on_incoming',

  /**
  * @summary Разрешить отказываться при подъехавшем авто
  * @description Разрешить отказываться от заказа путем нажатия на 0 даже если водитель уже подъехал
  */
  ROBOT_ALLOW_REJECT_ONPLACE: 'robot_allow_reject_onplace',

  /**
  * @summary Позволить покупать товары
  * @description Позволяет водителю покупать товары за его бонусы
  */
  DRIVER_BONUSES_ALLOW_BUY: 'driver_bonuses_allow_buy',

  /**
  * @summary Время ожидения ввода в голосовых меню
  * @description в секундах. Сколько ожидать ввода цифры от клиента после проигрывания голосового меню
  */
  ROBOT_IVR_TIMEOUT: 'robot_ivr_timeout',

  /**
  * @summary Проверять идентификатор устройства
  * @description Если включить, то водитель сможет подключиться только с одного устройства
  */
  LOGIN_CHECKUUID: 'login_checkuuid',

  /**
  * @summary Кэшировать ответы геокодера
  * @description Кэшировать результаты геокодинга в БД для уменьшения кол-ва запросов к сервису
  */
  CACHE_GEOCODER_RESULTS: 'cache_geocoder_results',

  /**
  * @summary Максимальная длина очереди
  * @description Максимальное число водителей в очереди, которых опрашивает система при поступлении заказа перед тем, как заказ переходит в свободные. При этом регистрация в очереди не запрещается. Укажите 0 для отключения ограничения
  */
  ORDER_MAX_QUEUE_REQUESTS: 'order_max_queue_requests',

  /**
  * @summary Использовать международный формат номера
  * @description При отправке будет использован номер в международном формате +79..., иначе 79....
  */
  SMS_ADDPLUS: 'sms_addplus',

  /**
  * @summary Включить реферальную систему
  */
  PROMOTIONAL_PROGRAM_ENABLED: 'promotional_program_enabled',

  /**
  * @summary Лимит по активациям
  * @description Максимальное количество активаций инвайт-кода
  */
  PROMOTIONAL_PROGRAM_INVITE_ACTIVATION_LIMIT: 'promotional_program_invite_activation_limit',

  /**
  * @summary Действителен, дней
  * @description Время действия инвайт-кода после его создания (в днях)
  */
  PROMOTIONAL_PROGRAM_INVITE_EXPIRES: 'promotional_program_invite_expires',

  /**
  * @summary Количество бонусов активации
  * @description Эти бонусы получит активировавший
  */
  PROMOTIONAL_PROGRAM_INVITE_ACTIVATE_BONUSES: 'promotional_program_invite_activate_bonuses',

  /**
  * @summary Количество бонусов владельцу
  * @description Эти бонусы получит владелец инвайт-кода
  */
  PROMOTIONAL_PROGRAM_INVITE_OWNER_BONUSES: 'promotional_program_invite_owner_bonuses',

  /**
  * @summary Минимальное количество заказов
  * @description Количество заказов, которое должен совершить клиент перед тем как получить возможность генерировать инвайт-код
  */
  PROMOTIONAL_PROGRAM_INVITE_ORDER_COUNT: 'promotional_program_invite_order_count',

  /**
  * @summary Максимально разрешенное кол-во заказов на одного водителя
  * @description Максимальное кол-во заказов, которое один водитель может закрепить за собой (0 - без ограничений).
  */
  RESERV_MAX_ORDERS: 'reserv_max_orders',

  /**
  * @summary Шаблон сообщения для стоимости сообщения
  * @description допустимые переменные<br/>%sum% - Стоимость
  */
  SMS_ONPLACEBILL_TEMPLATE: 'sms_onplacebill_template',

  /**
  * @summary Принудительная авто-регистрация водителей на стоянке
  * @description Свободные водители будут автоматически регистрироваться на стоянке без права сняться с регистрации
  */
  TERMINAL_AUTOREG_REQUIRED: 'terminal_autoreg_required',

  /**
  * @summary dest_addr_ton
  * @description возможные значения (в скобках цифровое значение параметра):<br/>UNKNOWN (0)<br/>INTERNATIONAL (1)<br/>NATIONAL (2)<br/>NETWORK_SPECIFIC (3)<br/>SUBSCRIBER_NUMBER (4)<br/>ALPHANUMERIC (5)<br/>ABBREVIATED (6)
  */
  SMS_DEST_ADDR_TON: 'sms_dest_addr_ton',

  /**
  * @summary Использовать ASCII кодировку
  * @description Позволяет увеличить максимальную длину сообщения, но допускает использование только латиницы. Все нелатинские символы будут заменены на знаки вопроса
  */
  SMS_USE_ASCII: 'sms_use_ascii',

  /**
  * @summary Протокол
  * @description Протокол используемый для общения с сервисом отправки sms
  */
  SMS_API_PROTOCOL: 'sms_api_protocol',

  /**
  * @summary Шаблон сообщения о машине
  * @description допустимые переменные: <br/>%time% - время подъезда<br/>%car% - марка автомобиля<br/>%color% - цвет автомобиля<br/>%number% - гос.номер автомобиля<br/>%dphone% - номер телефона водителя<br/>%name% - имя водителя<br/>%cost% - Стоимость
  */
  SMS_CFRM_TEMPLATE: 'sms_cfrm_template',

  /**
  * @summary Шаблон сообщения при подъезде машины
  * @description допустимые переменн<br/>%car% - марка автомобиля<br/>%color% - цвет автомобиля<br/>%number% - гос.номер автомобиля<br/>%dphone% - номер телефона водителя<br/>%name% - имя водителя<br/>%cost% - Стоимость
  */
  SMS_ONPLACE_TEMPLATE: 'sms_onplace_template',

  /**
  * @summary Макс. кол-во свободных
  * @description Максимальное кол-во заказов, отображаемое в списке свободных у водителя
  */
  ORDERS_MAX_FREEORDERS: 'orders_max_freeorders',

  /**
  * @summary Проверять баланс при подключении
  * @description Позволяет работать водителям в долг до изменения баланса (если отключить)
  */
  BILLING_CHECK_BALANCE_ON_CONNECT: 'billing_check_balance_on_connect',

  /**
  * @summary Предопределенные настройки
  * @description Выберите один из предопределенных наборов параметров
  */
  PRIORITY_PRESET: 'priority_preset',

  /**
  * @summary Скрыть запуск таксометра до подъезда к клиенту
  * @description При включении таксометр можно будет запустить только после подъезда к месту встречи клиента (после нажатия на кнопку "На месте")
  */
  TERMINAL_ONPLACE_IS_REQUIRED: 'terminal_onplace_is_required',

  /**
  * @summary Разрешить диспетчеру отправлять водителям заказы вдогонку
  * @description При включении данной настройки, диспетчер сможет отправлять заказы водителям вдогонку. При этом учитываются общие ограничения на количество заказов.
  */
  OPERATOR_ALLOW_ON_THE_RUN: 'operator_allow_on_the_run',

  /**
  * @summary Параметры функции плотности заказов
  * @description Параметры функции нормализации плотности заказов. Список параметров зависит от типа функции
  */
  PRIORITY_FUNC_DENSITY_PARAMS: 'priority_func_density_params',

  /**
  * @summary Функция(Кол-во отмененных заказов)
  * @description Функция нормализации кол-ва отмененных заказов
  */
  PRIORITY_FUNC_CANCELLED: 'priority_func_cancelled',

  /**
  * @summary Параметры функции кол-ва отмененных заказов
  * @description Параметры функция нормализации кол-ва отмененных заказов. Список параметров зависит от типа функции
  */
  PRIORITY_FUNC_CANCELLED_PARAMS: 'priority_func_cancelled_params',

  /**
  * @summary Количество 15-дневных периодов
  * @description Количество 15-дневных периодов, учитываемых при оценке плотности заказов
  */
  PRIORITY_PERIODS_CNT_15: 'priority_periods_cnt_15',

  /**
  * @summary Количество 30-дневных периодов
  * @description Количество 30-дневных периодов, учитываемых при оценке плотности заказов
  */
  PRIORITY_PERIODS_CNT_30: 'priority_periods_cnt_30',

  /**
  * @summary SMTP Сервер
  */
  EMAIL_NOTIFICATIONS_SMTP_HOST: 'email_notifications_smtp_host',

  /**
  * @summary Email-уведомления
  */
  EMAIL_NOTIFICATIONS_ACTIVE: 'email_notifications_active',

  /**
  * @summary Порт SMTP-сервера
  */
  EMAIL_NOTIFICATIONS_SMTP_PORT: 'email_notifications_smtp_port',

  /**
  * @summary Логин SMTP-сервера
  */
  EMAIL_NOTIFICATIONS_SMTP_LOGIN: 'email_notifications_smtp_login',

  /**
  * @summary Пароль SMTP-сервера
  */
  EMAIL_NOTIFICATIONS_SMTP_PASSWORD: 'email_notifications_smtp_password',

  /**
  * @summary TLS шифрование
  */
  EMAIL_NOTIFICATIONS_SMTP_TLS: 'email_notifications_smtp_tls',

  /**
  * @summary SSL шифрование
  */
  EMAIL_NOTIFICATIONS_SMTP_SSL: 'email_notifications_smtp_ssl',

  /**
  * @summary Показывать скидку до подтверждения
  * @description Включите эту опцию, чтобы водитель мог видеть скидки на заказах в списке свободных и при взятии заказов
  */
  TERMINAL_SHOW_DISCOUNT: 'terminal_show_discount',

  /**
  * @summary Время блокировки
  * @description Время блокировки при достижении порога блокировки. В часах
  */
  DRIVER_RATING_BLOCK_TIME: 'driver_rating_block_time',

  /**
  * @summary Период расчета
  * @description Количество дней, за которые будет производиться расчет рейтинга
  */
  DRIVER_RATING_CALCULATION_PERIOD_DAYS: 'driver_rating_calculation_period_days',

  /**
  * @summary Минимальное количество оценок
  * @description Рейтинг водителя будет считаться только в случае, если количество оценок достигнет этого числа
  */
  DRIVER_RATING_VOTES_NEED: 'driver_rating_votes_need',

  /**
  * @summary Заменить настройки начисления
  * @description Заменяет глобальные настройки начисления/снятия бонусов для этой службы выбранными ниже. В противном случае будет дополнять
  */
  DRIVER_BONUSES_EVENTS_REPLACE: 'driver_bonuses_events_replace',

  /**
  * @summary Разовая авторегистрация
  * @description Если активировать авторегистрация будет отключаться после определения и регистрации на стоянке
  */
  TERMINAL_AUTOREG_BUTTON_MODE: 'terminal_autoreg_button_mode',

  /**
  * @summary Запретить отмену заказов в исполнении
  * @description Если заказ ушел в исполнение и на нем есть ненулевой пробег, диспетчер не сможет отменить такой заказ или снять с него водителя
  */
  DISABLE_ORDER_IN_PROGRESS_CANCEL: 'disable_order_in_progress_cancel',

  /**
  * @summary Минимальный интервал в минутах между заказами
  * @description Минимальное время между заказами (При разрешении брать несколько предварительных заказов). 0 без ограничений
  */
  RESERV_MIN_INTERVAL: 'reserv_min_interval',

  /**
  * @summary Печать чеков
  * @description Включает возможность печати чека при помощи bluetooth принтера
  */
  TERMINAL_ENABLE_CKECK_PRINTER: 'terminal_enable_ckeck_printer',

  /**
  * @summary Запретить просматривать предварительные
  * @description Запретить отправлять список предварительных заказов водителям
  */
  RESERV_DONTSEND: 'reserv_dontsend',

  /**
  * @summary Учитывать время на предрасчете
  * @description Если настройка включена, то для предрасчета так же будет расчитано время. Если выключено, время будет принято равным нулю.
  */
  RATE_USE_PRELIMINARY_TIME: 'rate_use_preliminary_time',

  /**
  * @summary Запретить изменение доп. услуг водителем
  * @description Включите эту опцию, чтобы водитель не мог изменить доп. услуги на заказе
  */
  TERMINAL_NO_EXTRAS_CHANGE: 'terminal_no_extras_change',

  /**
  * @summary Запретить изменение тарифа водителем
  * @description Включите эту опцию, чтобы водитель не мог вручную изменить тариф на заказе
  */
  TERMINAL_NO_RATE_CHANGE: 'terminal_no_rate_change',

  /**
  * @summary Разрешить отказываться после бесплатного времени ожидания
  * @description Разрешить водителю отказываться от заказа после истечения бесплатного времени ожидания клиента
  */
  TERMINAL_ALLOW_REJECT_AFTER_FREE_TIME: 'terminal_allow_reject_after_free_time',

  /**
  * @summary Путь до файлов записи
  * @description путь до файлов с записью разговоров
  */
  MP3_PATH: 'mp3_path',

  /**
  * @summary Включить журнал
  * @description Все действия по заказам будут писаться в журнал
  */
  ORDER_LOGENABLE: 'order_logenable',

  /**
  * @summary Автоматически отказывать контрагентам
  * @description Включите эту опцию, чтобы отзвон об отсутствии машин выполнялся на заказах с контрагентом
  */
  COUNTERPARTY_AUTO_REJECT: 'counterparty_auto_reject',

  /**
  * @summary Запретить таксометр для заблокированных
  * @description Не позволяет запускать таксометр если водитель заблокирован или не подключен к серверу
  */
  TERMINAL_BLOCK_OFFLINE_TAXOMETR: 'terminal_block_offline_taxometr',

  /**
  * @summary Разрешить передачу заказов с допуслугами на биржу
  * @description При включении данной опции заказы с доп. услугами будет разрешено передавать на биржу
  */
  EXCHANGE_PASS_ORDERS_WITH_EXTRAS: 'exchange_pass_orders_with_extras',

  /**
  * @summary Разрешить звонки водителю на отправленных заказах
  * @description При включении данной опции диспетчера парков, получивших ваш заказ на бирже смогут совершать им прямой звонок через диспетчерскую
  */
  EXCHANGE_ALLOW_DRIVER_CALL: 'exchange_allow_driver_call',

  /**
  * @summary Комисия СберБанк
  * @description Оставьте 0 если не хотите применять комисию при зачислении средств водителям
  */
  BILLING_SB_MARGIN: 'billing_sb_margin',

  /**
  * @summary Интервал отсылки трека
  * @description через сколько секунд отсылать координаты трека на сервер. (точки пути на заказе)
  */
  TERMINAL_TRACK_INTERVAL: 'terminal_track_interval',

  /**
  * @summary Произовльные закладки с заказами
  * @description Настройки произвольных вкладок для диспетчерской
  */
  OPERATOR_CUSTOM_TABS: 'operator_custom_tabs',

  /**
  * @summary Пинг таймаут
  * @description максимальное время ожидания ответа от сервера
  */
  TERMINAL_PING_TIMEOUT: 'terminal_ping_timeout',

  /**
  * @summary Бесплатное ожидание
  * @description Время бесплатного ожидания (минут)
  */
  TERMINAL_FREE_TIMEOUT: 'terminal_free_timeout',

  /**
  * @summary Интервал сохранения состояния таксометра
  * @description через сколько секунд сохранять состояние таксометра в файл.<br/>Если во время работы таксометра выключится телефон или прекратит работу программа, на сервер при повторном подключении отправиться последнее состояние таксометра
  */
  TERMINAL_TAXOMETRSAVE_INTERVAL: 'terminal_taxometrsave_interval',

  /**
  * @summary Комисия при оплате через Qiwi
  * @description Комисия при зачислении на счет водителя в процентах
  */
  BILLING_QIWI_MARKUP: 'billing_qiwi_markup',

  /**
  * @summary Web-socket порт сервера
  */
  OPERATOR_SERVER_WS_PORT: 'operator_server_ws_port',

  /**
  * @summary Использовать  SSL
  */
  OPERATOR_USE_SSL: 'operator_use_ssl',

  /**
  * @summary Определение стоянки по координате
  * @description Пробовать определять стоянку по координате адреса.
  */
  ORDER_RGN_BY_COORDS: 'order_rgn_by_coords',

  /**
  * @summary Время действия счета Qiwi
  * @description Какое время (в часах) будет действовать выставленный счет
  */
  BILLING_QIWI_LTIME: 'billing_qiwi_ltime',

  /**
  * @summary Таймаут подключения
  * @description Значение таймаута подключения водительского приложения в секундах.
  */
  TERMINAL_CONNECTIONTIMEOUT: 'terminal_connectionTimeout',

  /**
  * @summary Автообновление списка свободных заказов
  * @description Будет автоматически обновлять список свободных заказов через заданный интервал секунд. Поставьте 0 для отключения
  */
  TERMINAL_FOUPDATEINTERVAL: 'terminal_foUpdateInterval',

  /**
  * @summary Идентификатор клиента СберБанк
  */
  BILLING_SB_ID: 'billing_sb_id',

  /**
  * @summary Пароль клиента СберБанк
  */
  BILLING_SB_PASSWORD: 'billing_sb_password',

  /**
  * @summary Проверять подпись СберБанк
  * @description Проверяеть электронную подпись в запросах от сбербанка
  */
  BILLING_SB_CHECKSIGN: 'billing_sb_checksign',

  /**
  * @summary Жестко закреплять водителя за заказом
  * @description При закреплении водителя за заказом из диспетчерской будет игнорироваться таймер передачи заказа следующему (если водитель не получил заказ или не среагировал за отведенное время)
  */
  ORDER_SETDRIVERHARD: 'order_setdriverhard',

  /**
  * @summary Максимальная версия для Symbian
  * @description Максимально допустимая версия ПО для коммуникаторов на базе Symbian
  */
  SOFT_MAXVERSION_SYMBIAN: 'soft_maxversion_symbian',

  /**
  * @summary Максимальная версия для Windows Mobile
  * @description Максимально допустимая версия ПО для коммуникаторов на базе Windows Mobile
  */
  SOFT_MAXVERSION_WM: 'soft_maxversion_wm',

  /**
  * @summary Требовать шифрованное соединение терминалов
  * @description При подключении на незащищенный порт будет выдана ошибка о том, что нужно подключиться на защищенный порт
  */
  REQUIRE_SSL_TAXER: 'require_ssl_taxer',

  /**
  * @summary Показывать статус подключения в диспетчерской
  * @description Отображать, подключен ли водитель в диспетчерской
  */
  SHOW_DRIVER_STATUS: 'show_driver_status',

  /**
  * @summary Разрешить назначать водителя
  * @description Если включена, диспетчер сможет назначать водителя вручную
  */
  ORDER_SETDRIVERMANUAL: 'order_setdrivermanual',

  /**
  * @summary Искать адрес сразу после ввода улицы
  * @description Поиск адреса будет производиться даже если адрес дома не указан
  */
  OPERATOR_STREET_GEOCODE: 'operator_street_geocode',

  /**
  * @summary Время до "отказа"
  * @description сколько программе ждать до звонка клиенту с сообщение что нет машин
  */
  ROBOT_REJECT_TIMEOUT: 'robot_reject_timeout',

  /**
  * @summary Описание
  * @description Описание, отображаемое водителям. Может содержать информацию о призовых местах
  */
  VMIG_RATING_DESCRIPTION: 'vmig_rating_description',

  /**
  * @summary Ограничить поиск координат по базе адресов
  * @description При включении данной опции, поиск координат для создаваемых заказов будет производиться только для улиц, присутствующих в базе адресов СКАТ(Раздел панели администратора "Адреса" -> "Улицы")
  */
  GEO_WHITELIST_STREETS: 'geo_whitelist_streets',

  /**
  * @summary Служба
  * @description Использовать указанную службу для получения настроек
  */
  DRIVER_BONUSES_USE_SERVICE: 'driver_bonuses_use_service',

  /**
  * @summary Язык по-умолчанию
  * @description Будет использован для сообщений от сервера диспетчерам, а также водителям, у которых не указан язык
  */
  DEFAULT_LANGUAGE: 'default_language',

  /**
  * @summary Валюта
  * @description Валюта таксометра
  */
  TERMINAL_CURRENCY: 'terminal_currency',

  /**
  * @summary Начальная дата периода
  * @description Дата начала подсчета заказов
  */
  VMIG_RATING_START_DATE: 'vmig_rating_start_date',

  /**
  * @summary ИД клиента
  */
  CLIENT_ID: 'client_id',

  /**
  * @summary Считать стоянку без GPS
  * @description Внимание!!! Включать только при необходимости использования стояночного счетчика в условиях отсутствия сигнала GPS, например в помещения/складах
  */
  TERMINAL_TAXOMETR_STAND_WITHOUT_GPS: 'terminal_taxometr_stand_without_gps',

  /**
  * @summary Комментарий
  * @description Указанная отметка будет добавлена в комментарий автоматических заказов
  */
  STT_COMMENT: 'stt_comment',

  /**
  * @summary Разрешить автоприем заказов
  * @description Определяет, будет ли осуществляться автоматический прием заказов
  */
  STT_ENABLE: 'stt_enable',

  /**
  * @summary Проверять адрес
  * @description Проверяет наличие улицы, возвращенной от сервера, в базе данных
  */
  STT_VALIDATE_STREET: 'stt_validate_street',

  /**
  * @summary Определять координаты
  * @description Определять координаты адреса тарифным сервером
  */
  STT_LOCAL_GEOCODE: 'stt_local_geocode',

  /**
  * @summary Принимать заказы контрагентов
  * @description Принимать заказы от контрагентов роботом
  */
  STT_ACCEPT_CUSTOMER: 'stt_accept_customer',

  /**
  * @summary Разрешить только корректную точку назначения
  * @description При включении данной настройки будет проводиться полная проверка правильности конечного адреса
  */
  STT_FORCE_VALID_DESTINATION: 'stt_force_valid_destination',

  /**
  * @summary Адрес внешнего сервиса городов
  * @description Сервис будет использоваться для поиска городов в диспетчерской
  */
  OPERATOR_CITY_SERVICE_PATH: 'operator_city_service_path',

  /**
  * @summary Ограничение времени забора заказа курьерами
  * @description JSON объект
  */
  OPERATOR_DELIVERY_PICKUP_LIMIT: 'operator_delivery_pickup_limit',

  /**
  * @summary Интерфейс для AGI
  * @description Интерфейс который будет принимать AGI подключения
  */
  AGI_INTERFACE: 'agi_interface',

  /**
  * @summary КитИнвест статус агента
  */
  CHECK_CUSTOMER_AGENT: 'check_customer_agent',

  /**
  * @summary Отправлять номер телефона
  * @description Отправлять номер клиента при фискализации. В этом случае будет отправлена смс с сылкой на электронный чек
  */
  CHECK_SEND_PHONE: 'check_send_phone',

  /**
  * @summary Основной порт
  * @description Основной порт для подключения водителей
  */
  CONNECTION_MAIN_PORT: 'connection_main_port',

  /**
  * @summary Включить фискализацию
  * @description Активирует возможность фискализации оплаты через сервисы онлайн фискализации
  */
  TERMINAL_CHECK_ENABLE: 'terminal_check_enable',

  /**
  * @summary Учитывать количество дней
  * @description При принятии решения о направлении заказа на робота будут использованы заказы за указанное кол-во дней
  */
  STT_STAT_DAYS: 'stt_stat_days',

  /**
  * @summary Верхний порог(%)
  * @description Если процентное соотношение успешных заказов через робота для клиента выше указанного, то он всегда будет направляться на робота
  */
  STT_PMAX: 'stt_pmax',

  /**
  * @summary Нижний порог(%)
  * @description Если процентное соотношение успешных заказов через робота для клиента ниже указанного, то он всегда будет направляться диспетчеру
  */
  STT_PMIN: 'stt_pmin',

  /**
  * @summary Пропускать заказы
  * @description При неудачном заказе через робота, это количество заказов будет безусловно направлено диспетчеру
  */
  STT_ROBOT_SKIPS: 'stt_robot_skips',

  /**
  * @summary Минимальное количество попыток через робота
  * @description Верхний и нижний пороги будут использованы только если общее число успешных и неуспешных заказов направленных роботу не ниже заданного значения.
  */
  STT_MIN_LIMIT: 'stt_min_limit',

  /**
  * @summary Веб-сервис
  * @description Если сервер подключен к интернету посредством роутера, укажите, с какого порта настроен проброс на веб-сервис
  */
  TERMINAL_WEBPORT: 'terminal_webport',

  /**
  * @summary Скрытая настройка
  * @description Ограничить историю заказов на N дней в личном кабинете водителя
  */
  CABINET_HISTORY_LIMIT_DAYS: 'cabinet_history_limit_days',

  /**
  * @summary Скрытая настройка
  * @description Дополнительные произвольные ссылки для кабинета водителя
  */
  EXTRA_LINKS: 'extra_links',

  /**
  * @summary Скрытая настройка
  * @description Звонить до поднятия трубки (актуально только для веб-диспетчерской)
  */
  OPERATOR_ENDLESS_RING: 'operator_endless_ring',

  /**
  * @summary Скрытая настройка
  * @description Сохранять заказ, при нажатии на кнопку удержания
  */
  USE_WAIT_AS_DEFAULT_ACTION: 'use_wait_as_default_action',

  /**
  * @summary Скрытая настройка
  * @description Настройки "по умолчанию" для пользовательских настроек диспетчерской панели
  */
  OPERATOR_CUSTOM_PREFERENCES: 'operator_custom_preferences'
};
exports.SETTINGS = SETTINGS;